var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M20,6H12L10,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8A2,2 0 0,0 20,6M15,16H6V14H15V16M18,12H6V10H18V12Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }